import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // optional global styles
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MihuThemeProvider } from './theme/mihuTheme';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MihuThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </MihuThemeProvider>
  </React.StrictMode>,
);


